import { Link } from "react-router-dom";
// import arrowup from "../../assets/arrowup.png";

const Panels = () => {
    // Retrieve both users from localStorage
    const adminUser = JSON.parse(localStorage.getItem("Admin"));
    const blogWriterUser = JSON.parse(localStorage.getItem("Blogger"));

    // Determine the current user
    const currentUser = adminUser || blogWriterUser;
    const currentUrl = window.location.href;

    // Define the panels array
    const panels = [

        {
            panel: "Ongoing Project",
            url: `/ProjectsAdminPanel`,
            roles: ["admin"],
        },
        {
            panel: "Completed Project",
            url: `/ProjectCompletePanel`,
            roles: ["admin"],
        },
        {
            panel: "Testimonials Panel",
            url: `${currentUrl}/testimonialadminpanel`,
            roles: ["admin"],
        },
        {
            panel: "Careers Panel",
            url: `${currentUrl}/careeradminpanel`,
            roles: ["admin"],
        },
    ];

    // Filter panels based on the current user's role
    const filteredPanels = panels.filter((panel) =>
        currentUser ? panel.roles.includes(currentUser.role) : false
    );

    return (
        <div className="flex items-center justify-center gap-10">
            {filteredPanels.map((items, i) => (
                <Link
                    key={i}
                    to={items.url}
                    className="group  p-6 px-10 rounded-lg border-[1px] border-[#2f2f2f] hover:bg-[#990000] transition-all"
                >
                    <div className="flex items-start justify-center">
                        <p className="text-lg group-hover:text-white px-1">
                            {items.panel}
                        </p>
                        {/* <img
                            src={arrowup}
                            alt="arrow"
                            className="w-4 transition-all group-hover:invert rotate-[135deg] -mt-2"
                        /> */}
                    </div>
                </Link>
            ))}
        </div>
    );
};

export default Panels;
